import React, { useState } from "react";
import "./BackendDeveloper.css";
import { Container } from "react-bootstrap";
import JobApplicationModal from "../../components/JobApplicationModal/JobApplicationModal";
import { useParams } from "react-router-dom";
import { useLanguage } from "../../Context/LanguageContext";
import { useQuery } from "@tanstack/react-query";
import Loader from "../../components/Loader/Loader";
import arrowRight from "../../assets/utility_images/arrow-right.svg";
import arrowRightWhite from "../../assets/utility_images/arrow-right-white.svg";

const BackendDevloper = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // Extract and process sections

  return (
    <div>
      <Container fluid style={{ paddingLeft: 0, paddingRight: 0 }}>
        <section className="privacy-policy-section">
          <div className="privacy-policy">
            {/* Render the first section separately */}

            <div className="policy-description">
              <div className="privacy-heading">
                JD202: Backend and Data Processing Engineer
              </div>
              <div className="job-description">
                We are seeking a Backend and Data Processing Engineer to join
                our team. In this role, you will be responsible to develop CRM
                system on AWS for data integration from each ERP system and
                connecting with the messaging hub system.
                <br />
                You will work closely with front-end developers, data
                scientists, and other stakeholders to ensure that our systems
                are scalable, reliable, and performant.
                <br />
                You will be responsible in creating a robust and secure
                AWS-based data lake by collecting diverse data sources and
                standardization.
              </div>
            </div>
            <div className="value-header mt-4">
              Experience Level: 3 ~ 4 years.
            </div>
            {/* Render the other sections */}

            <div className="policy-description">
              <div className="value-header mt-4">Key Responsibilities</div>
              <div className="job-description">
                <ul>
                  <li>
                    Standardize data and store/manage it in an AWS-based data
                    lake.
                  </li>
                  <li>
                    Collect customer data such as reservations, memberships, and
                    payments from ERP systems across various locations.
                  </li>
                  <li>
                    Implement automation for data pipelines and data consistency
                    verification logic.
                  </li>
                  <li>
                    Design marketing triggers based on customer journeys and
                    implement automated scenario execution logic.
                  </li>
                  <li>
                    Integrate with internal messaging hub systems to
                    automatically send personalized SMS, emails, and
                    notifications.
                  </li>
                  <li>
                    Design structures for collecting data on message delivery
                    results and user responses.
                  </li>
                </ul>
              </div>
              <div className="value-header mt-4">
                Required Skills & Qualifications
              </div>
              <div className="job-description">
                <ul>
                  <li>
                    Proficiency in backend development using Python, Node.js,
                    etc.
                  </li>
                  <li> Experience designing and developing RESTful APIs.</li>
                  <li>
                    Skilled in SQL-based data analysis and database design.
                  </li>
                  <li>
                    Experience in collecting and standardizing data from
                    external systems such as ERP.
                  </li>
                  <li> Familiarity with ETL automation and scheduling.</li>

                  <li> Experience in integrating with messaging systems.</li>
                  <li>
                    Bachelor or Master's degree in Computer Science or related
                    field.
                  </li>
                  <li>
                    Relevant backend and data pipeline building experience is
                    crucial.
                  </li>
                  <li>
                    Prior experience on CRM systems development / integration is
                    preferred for this position.
                  </li>
                </ul>
              </div>

              <button
                className="btn-job  d-flex justify-content-evenly align-items-center"
                onClick={handleShow} // Show modal on click
              >
                Apply
                <div className="hero-btn">
                  <img
                    className="hover-arrow"
                    src={arrowRight}
                    alt=""
                    loading="lazy"
                  />
                  <img
                    className="hover-arrow-white"
                    src={arrowRightWhite}
                    alt=""
                    loading="lazy"
                  />
                </div>
              </button>
            </div>
          </div>
        </section>
      </Container>
      <JobApplicationModal show={show} handleClose={handleClose} />
    </div>
  );
};

export default BackendDevloper;
